import { ICashFlowFLI } from './ICashFlowFLI.interface';

export interface ICashFlowFinancingActivitiesComponentInput {
    title: string;
    flis: ICashFlowFLI[];
    currentYearDate: string;
    previousYearDate: string;
    currency: string;
}
